import { useEffect, useState } from 'react';
import { sortMap } from './common';
import { Button } from 'react-bootstrap';

export default function FiltersSelected(props) {
  const [filtersMap, setFiltersMap] = useState(new Map());

  useEffect(() => {
    let newFiltersMap = new Map();

    props.filters?.forEach((filter) => {
      if (newFiltersMap.has(filter.key)) {
        newFiltersMap.get(filter.key).push(filter.label);
      } else {
        newFiltersMap.set(filter.key, [filter.label]);
      }
    });

    // Sort newFiltersMap based on props.sortedColumns sortOrder
    newFiltersMap = sortMap(newFiltersMap, props.sortedColumns);
    setFiltersMap(newFiltersMap);
  }, [props.filters, props.sortedColumns]);

  return (
    <div className="filter-section">
      <div className="filters-selected">
        {props.filters?.length > 0 && (
          <>
            <span className="filters-applied-label">Applied Filters:</span>{' '}
            {Array.from(filtersMap).map(([key, value]) => (
              <div
                key={key}
                className={props.filterCSSClass?.[key] ?? 'filter-item'}
                onClick={() => props.onFilterClick(key)}
                title={props.filters
                  ?.map((filter) => {
                    return filter.key === key ? filter.label : null;
                  })
                  .filter((label) => label !== null)
                  .join(', ')}
              >
                <span className="filter-key">{key}</span>:{' '}
                {value.forEach((v, i) => {
                  if (v.length > 15) {
                    value[i] = v.substring(0, 12) + '...';
                  }
                })}
                {value.join(', ').length > 30 ? (
                  <span className="filter-value">
                    {value.join(', ').substring(0, 27) + '...'}
                  </span>
                ) : (
                  <span className="filter-value">{value.join(', ')}</span>
                )}
              </div>
            ))}
          </>
        )}
      </div>
      <div className="filter-buttons">
        <Button
          variant="outline-primary"
          className="filter-button"
          onClick={() => {
            props.getSearchResults();
          }}
        >
          Apply Filters
        </Button>
        <Button
          variant="outline-primary"
          className="filter-button"
          onClick={() => {
            props.clearAllFilters();
          }}
        >
          Clear All Filters
        </Button>
      </div>
    </div>
  );
}
